import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import { getWebPageSchema, getBreadcrumbSchema } from '@/lib/schema';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd schema={getWebPageSchema('/privacy', 'Informativa sulla Privacy - Itaobuy Spreadsheet Italia', 'Informativa sulla privacy di Itaobuy Spreadsheet Italia. Dettagli su raccolta dati, cookie, fornitori di servizi e diritti degli utenti.')} />
      <JsonLd schema={getBreadcrumbSchema([{ name: 'Home', url: '/' }, { name: 'Privacy Policy', url: '/privacy' }])} />
      <Navbar />
      <section className="w-full px-6 md:px-10 pt-28 pb-12 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <nav className="flex items-center gap-2 text-xs font-body text-foreground-500 mb-6 flex-wrap" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">Home</Link>
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-arrow-right-s-line text-xs"></i></span>
            <span className="text-foreground-400 whitespace-nowrap">Privacy Policy</span>
          </nav>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-8">
            Informativa sulla Privacy
          </h1>
          <p className="font-body text-sm text-foreground-500 mb-8">Ultimo aggiornamento: Luglio 2026</p>

          <div className="prose prose-sm max-w-none space-y-8">
            <section>
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-4">1. Introduzione</h2>
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                Itaobuy Spreadsheet Italia (&quot;noi&quot;, &quot;ci&quot; o &quot;nostro&quot;) gestisce il sito web itaobuyspread.sbs (il &quot;Servizio&quot;). Questa pagina ti informa delle nostre politiche riguardanti la raccolta, l&apos;uso e la divulgazione dei dati personali quando utilizzi il nostro Servizio.
              </p>
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                Non raccoglieremo né utilizzeremo le tue informazioni se non come descritto nella presente Informativa sulla Privacy. Utilizziamo i tuoi dati personali per fornire e migliorare il Servizio. Utilizzando il Servizio, accetti la raccolta e l&apos;utilizzo delle informazioni in conformità con questa informativa.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-4">2. Raccolta e Utilizzo dei Dati</h2>
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                Durante l&apos;utilizzo del nostro Servizio, potremmo raccogliere determinate informazioni personali identificabili che possono essere utilizzate per contattarti o identificarti. Le informazioni personali identificabili possono includere, ma non sono limitate a:
              </p>
              <ul className="list-disc list-inside space-y-2 font-body text-sm md:text-base text-foreground-700 leading-relaxed ml-4">
                <li>Indirizzo email (quando ti iscrivi alla nostra newsletter)</li>
                <li>Dati di utilizzo (pagine visitate, tempo di permanenza, clic)</li>
                <li>Cookie e tecnologie di tracciamento simili</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-4">3. Cookie</h2>
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                I cookie sono file con una piccola quantità di dati che possono includere un identificatore univoco anonimo. I cookie vengono inviati al tuo browser da un sito web e memorizzati sul disco rigido del tuo computer.
              </p>
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                Utilizziamo i &quot;cookie&quot; per raccogliere informazioni e migliorare il nostro Servizio. Puoi istruire il tuo browser a rifiutare tutti i cookie o a indicare quando un cookie viene inviato. Tuttavia, se non accetti i cookie, potresti non essere in grado di utilizzare alcune parti del nostro Servizio.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-4">4. Fornitori di Servizi</h2>
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                Potremmo impiegare società e individui terzi per facilitare il nostro Servizio, fornire il Servizio per nostro conto, eseguire servizi correlati al Servizio o assisterci nell&apos;analisi di come viene utilizzato il nostro Servizio.
              </p>
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                Questi terzi hanno accesso ai tuoi dati personali solo per eseguire questi compiti per nostro conto e sono obbligati a non divulgarli o utilizzarli per nessun altro scopo.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-4">5. Collegamenti ad Altri Siti</h2>
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                Il nostro Servizio può contenere collegamenti ad altri siti che non sono gestiti da noi. Se fai clic su un collegamento di terzi, verrai indirizzato al sito di quel terzo. Ti consigliamo vivamente di esaminare l&apos;Informativa sulla Privacy di ogni sito che visiti.
              </p>
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                Non abbiamo alcun controllo e non ci assumiamo alcuna responsabilità per il contenuto, le informative sulla privacy o le pratiche di siti o servizi di terzi.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-4">6. Sicurezza</h2>
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                La sicurezza dei tuoi dati personali è importante per noi, ma ricorda che nessun metodo di trasmissione su Internet o metodo di archiviazione elettronica è sicuro al 100%. Mentre ci sforziamo di utilizzare mezzi commercialmente accettabili per proteggere i tuoi dati personali, non possiamo garantirne la sicurezza assoluta.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-4">7. Contatti</h2>
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                Se hai domande su questa Informativa sulla Privacy, puoi contattarci visitando il nostro sito principale:{" "}
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-500 underline cursor-pointer">
                  kaspreadsheet.com
                </a>
              </p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-background-200">
            <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 border border-primary-300 text-primary-600 font-label text-sm font-semibold rounded-full hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-arrow-left-line text-sm"></i>
              Torna alla Home
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}